import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import HeaderVendorPage from '../../components/HeaderVendorHome';
import axiosInstance from '../../../axiosInstance';
import toast from 'react-hot-toast';
import getDecryptData from '../../../helper/getDecryptData';
import LoadingScreen from '../../components/LoadingScreen';
const MySwal = withReactContent(Swal);

const VendorAllPendingOrder = () => {


    const [Dloading, setDLoading] = useState(true);
    const [getDriver, setDriver] = useState(false);
    const [AllDriver, setAllDriver] = useState([]);
    const [DriverId, setDriverId] = useState(null);
    const [OrderId, setOrderId] = useState(null);

    const handleDriverChange = (OrderId) => async (event) => {

        const DriverId = event.target.value;
        if (DriverId !== undefined) {
            setDriverId(DriverId);
        }


    };

    const selectDriver = async (OrderId, driver, cat, type, distance, empType) => {
        fetchemployeeData(cat, type, empType, distance);
        setOrderId(OrderId);
        setDriverId(driver);
    }

    const fetchemployeeData = async (cat, type, empType, distance) => {
        setAllDriver([]);
        try {

            const response = await axiosInstance.get(`/all-employee?type=${type}&longitude=${distance?.longitude || ''}&latitude=${distance?.latitude || ''}&empType=${empType}`);


            const { success, users } = response.data;
            if (success) {
                console.log('Users', response.data);

                setAllDriver(users);
            }

        } catch (error) {
            console.error('Error fetching Driver:', error);

        }

    };

    const handleClickDriverChange = async () => {
        setDLoading(true);
        try {
            const data = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { agentId: DriverId });
            const { success } = data.data;
            if (success) {
                console.log(data)
                setDLoading(false);
                toast.success("Employee Updated success!");
            }


        } catch (error) {
            console.error('Error Updated Employee', error);
            setDLoading(false);
        } finally {
            fetchData();
        }
    }

    const handleClickAsignChange = async () => {
        setDLoading(true);
        try {
            const data = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { asignId: DriverId });
            const { success } = data.data;
            if (success) {
                console.log(data)
                setDLoading(false);
                toast.success("Vendor Updated success!");
            }


        } catch (error) {
            console.error('Error Updated Vendor', error);
            setDLoading(false);
        } finally {
            fetchData();
        }
    }


    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const [formData, setFormData] = useState({
        status: "",
    });

    const decryptdatajson = getDecryptData();

    const fetchData = async () => {

        let employeeId = null;
        const id = decryptdatajson?._id;
        if (decryptdatajson.type === 1 && decryptdatajson.empType === 2) {
            employeeId = id
        }

        try {
            setLoading(true);
            const response = await axiosInstance.get(`/admin/all-order?page=${currentPage}&limit=${limit}&search=${searchTerm}&status=${'1,2,3,4,5,6,7'}&employeeId=${employeeId}`);
            setData(response.data.Order || []);
            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            console.log(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
            setData([]);
            setCurrentPage(1);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage, limit]);




    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    // Function to handle delete
    const handleDelete = (categoryId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup', // Add a class to the entire dialog
                confirmButton: 'btn-danger', // Add a class to the confirm button
            },
        }).then((result) => {
            if (result.isConfirmed) {


                axiosInstance.delete(`/admin/delete-order/${categoryId}`)
                    .then(() => {
                        // Refresh the data or update the state after successful deletion
                        fetchData();
                        toast.success("Deleting Order success!");
                    })
                    .catch((error) => {
                        console.error('Error deleting data:', error);
                        toast.error("Error deleting data");
                    });
            }
        });
    };


    const handleStatusChange = (ratingId) => async (event) => {
        const newStatus = event.target.value;
        setLoading(true);

        try {
            await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: newStatus });
            setLoading(false);
            fetchData(currentPage);
            toast.success("Status Updated success!");
        } catch (error) {
            console.error('Error updating rating status:', error);
            setLoading(false);
        }

    };



    const handleLeadStatusChange = (statusId, type) => async (event) => {
        const newStatus = event.target.value;

        if (type === 'custom' && newStatus === '2') {  // If status is "Order Accepted"
            // Use SweetAlert2 to prompt the admin for the final price
            const { value: finalPrice } = await Swal.fire({
                title: 'Enter the Final Price',
                input: 'number',
                inputLabel: 'Final Price',
                inputPlaceholder: 'Enter the final price here',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Final price is required';
                    }
                    if (isNaN(value) || parseFloat(value) <= 0) {
                        return 'Please enter a valid price greater than zero';
                    }
                },
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                preConfirm: (price) => {
                    return price;
                }
            });

            if (finalPrice) {
                sendUpdateToServer(newStatus, statusId, finalPrice);  // Call function to send both status and price
            } else {
                toast.error('Final price is required!');
            }
        } else {
            sendUpdateToServer(newStatus, statusId);  // If status isn't "Order Accepted", just update the status
        }
    };

    const sendUpdateToServer = async (status, statusId, finalPrice = null) => {
        setLoading(true);

        try {
            const requestData = finalPrice
                ? { status: status, final_price: finalPrice }
                : { status: status };

            await axiosInstance.put(`/admin/update-order/${statusId}`, requestData);

            setLoading(false);
            fetchData(currentPage);  // Assuming you have a function to refresh data
            toast.success("Status updated successfully!");
        } catch (error) {
            console.error('Error updating status:', error);
            setLoading(false);
            toast.error("Error updating status.");
        }
    };


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));

    };


    const inputRef = React.createRef();

    const handleSearchInputChange = (e) => {
        setCurrentPage(1);
        setTotalPages(1);
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        fetchData(currentPage);
    };


    // Function to handle delete
    const handleCancelOrder = (categoryId) => {
        if (!formData.comment || formData.comment === '') {
            toast.error('Comment is required');
            return null;
        }

        const mycomment = `Cancelled by Admin: ${formData.comment}`;

        MySwal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Cancel it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup', // Add a class to the entire dialog
                confirmButton: 'btn-primary', // Add a class to the confirm button
            },
        }).then((result) => {
            if (result.isConfirmed) {

                axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment })
                    .then(() => {
                        // Refresh the data or update the state after successful deletion
                        fetchData();
                        toast.success("Cancel Order Successfully!");
                        setFormData([]);

                    })
                    .catch((error) => {
                        console.error('Error Mark Done:', error);
                        toast.error("Error Cancel Order");

                    });
            }
        });
    };


    // Function to handle delete
    const handleCompleteOrder = (categoryId) => {
        if (!formData.otp || formData.otp === '') {
            toast.error('OTP is required');
            return null;
        }

        const myotp = Number(formData.otp);

        MySwal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Complete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup', // Add a class to the entire dialog
                confirmButton: 'btn-primary', // Add a class to the confirm button
            },
        }).then((result) => {
            if (result.isConfirmed) {

                axiosInstance.put(`/complete-order/${categoryId}`, { otp: myotp })
                    .then(() => {
                        // Refresh the data or update the state after successful deletion
                        fetchData();
                        toast.success("Complete Order Successfully!");
                        setFormData([]);
                    })
                    .catch((error) => {
                        console.error('Error Mark Done:', error);
                        toast.error(error.response.data.message ?? 'Error on complete order!');

                    });
            }
        });
    };



    const getStatusText = (status) => {
        switch (status) {
            case 1:
                return 'Order Placed';
            case 2:
                return 'Order Accepted';
            case 3:
                return 'Order Confirmed';
            case 4:
                return 'Processing';
            case 5:
                return 'Started';
            case 6:
                return 'Shipped';
            case 7:
                return 'Ready For Pickup';
            default:
                return 'Unknown Status';
        }
    };

    const getCustomStatusText = (status) => {
        switch (status) {
            case 1:
                return 'Pending';
            case 2:
                return 'Final Price';
            case 3:
                return 'Placed';
            case 4:
                return 'Confirmed';
            case 5:
                return 'Processing';
            case 6:
                return 'Started';
            case 7:
                return 'Ready For Pickup';
            default:
                return 'Unknown Status';
        }
    };



    return (
        <>

            <HeaderPage title="Pending Orders" />

            <main className="page-content  mypadding bg-light overflow-auto pb-4" >






                <div className="w-100">
                    <div className="px-3 pt-2 py-4">


                        {loading ? (
                            <LoadingScreen />
                        ) : (
                            <>


                                <div className="datatable-top">
                                    <div className="mb-2">
                                        <label>
                                            <select className="border rounded-sm px-2 py-1" value={limit} onChange={(e) => {
                                                setlimit(parseInt(e.target.value, 10));
                                                setCurrentPage(1); // Reset current page to 1 when the limit changes
                                            }} >
                                                <option value={5}>5</option>
                                                <option value={10} >
                                                    10
                                                </option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                                <option value={25}>25</option>
                                            </select>{" "}

                                            entries per page
                                        </label>
                                    </div>



                                    <div className="d-flex align-items-center gap-2 mb-3">
                                        <div className="datatable-search w-100">
                                            <input
                                                className="w-100 form-control form-control-sm"
                                                type="text"
                                                placeholder="Search...(By Order ID)" value={searchTerm}
                                                onChange={handleSearchInputChange}
                                            />
                                        </div>
                                        <button className="btn btn-primary btn-sm" onClick={handleSearch}> Search
                                        </button>

                                    </div>
                                </div>



                                <div className="w-100">
                                    {data.length === 0 && (
                                        <div className="text-center text-muted py-5">
                                            <i className="ri-inbox-2-line fs-1"></i>
                                            <p className="mt-2">No Orders Found</p>
                                        </div>
                                    )}


                                    <div className="row g-3">
                                        {data.length !== 0 && data.map((row) => (
                                            <div className="col-12" key={row._id}>
                                                <div className="card shadow-sm border-0 h-100">
                                                    <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                                        <h6 className="mb-0 text-white">Order ID: {row.orderId}</h6>
                                                        {row.items[0]?.id === '1' ? (
                                                            <span className="badge bg-success">Custom</span>
                                                        ) : (
                                                            <span className="badge bg-dark">Normal</span>
                                                        )}
                                                    </div>

                                                    <div className="card-body">
                                                        {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) && (
                                                            <>
                                                                <h6 className="fw-bold text-secondary">User Details</h6>
                                                                <p className="mb-2 small">
                                                                    <b>Name:</b> {row?.details[0]?.username || "NA"} <br />
                                                                    <b>Phone:</b> {row?.details[0]?.phone || "NA"}
                                                                </p>
                                                            </>
                                                        )}


                                                        <div className="d-flex gap-2 justify-content-between">

                                                            <div className="col-6">
                                                                <h6 className="fw-medium text-dark mt-3">Order Details</h6>

                                                                <Link className="btn btn-sm btn-dark" to={`/order/${row._id}`}>
                                                                    View Order
                                                                </Link>
                                                            </div>

                                                            <div className="col-6">
                                                                <h6 className="fw-medium text-dark mt-3">Order Status</h6>
                                                                <div className="mb-2">
                                                                    {row.status !== 0 && row.status !== 8 ? (
                                                                        <>
                                                                            {row.items[0]?.id !== '1' ? (
                                                                                // If the condition for `row.items[0]?.id !== '1'` holds true, show the status as text
                                                                                <span className="p-2 badge bg-dark">{getStatusText(row.status)}</span>
                                                                            ) : (
                                                                                // If `row.items[0]?.id === '1'`, show the status as text
                                                                                <span className="p-2 badge bg-dark">{getCustomStatusText(row.status)}</span>
                                                                            )}

                                                                        </>
                                                                    ) : row.status === 8 ? (
                                                                        <>
                                                                            <span className="badge bg-success">Completed</span>

                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span className="badge bg-danger">Cancelled</span>
                                                                            <p className="small pt-2 border-top mt-2 mb-0">
                                                                                <b>Comment:</b> {row.comment || '—'}
                                                                            </p>
                                                                        </>
                                                                    )}


                                                                </div>
                                                            </div>


                                                        </div>

                                                    </div>

                                                    {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) && (
                                                        <div className="card-footer bg-light text-end">
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(row._id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>



                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap mb-4">

                                    {/* Left side: Page info */}
                                    <div className="text-muted mb-2 mb-md-0">
                                        Showing Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                                    </div>

                                    {/* Right side: Pagination controls */}
                                    <nav aria-label="Page navigation">
                                        <ul className="pagination mb-0">
                                            {/* Previous Button */}
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={handlePreviousPage}
                                                    disabled={loading || currentPage === 1}
                                                    aria-label="Previous"
                                                >
                                                    ‹ Prev
                                                </button>
                                            </li>

                                            {/* Current Page */}
                                            <li className="page-item active">
                                                <span className="page-link">
                                                    {currentPage}
                                                </span>
                                            </li>

                                            {/* Next Button */}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={handleNextPage}
                                                    disabled={loading || currentPage === totalPages}
                                                    aria-label="Next"
                                                >
                                                    {loading ? (
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        'Next ›'
                                                    )}
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>

                                </div>



                            </>
                        )}
                    </div>
                </div >


                <div
                    className="modal fade"
                    id="modal-driver"
                    tabIndex={-1}
                    aria-labelledby="modal-driver"
                    style={{ display: "none" }}
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="mb-0">
                                    <label htmlFor="eventTitle">

                                        Choose Employee
                                    </label>{" "}

                                    <select
                                        className="form-control select"
                                        name="status"
                                        style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}
                                    >
                                        <option > Select Employee</option>


                                        {AllDriver.length > 0 ? (

                                            AllDriver.map(driver => (
                                                <option value={driver._id} key={driver._id} selected={driver._id === DriverId}
                                                    style={{ color: driver.online === 1 ? 'green' : driver.online === 0 && 'red' }}> {driver?.distance?.kilometers !== 0 && driver?.distance?.kilometers &&
                                                        <>
                                                            ( {driver?.distance?.kilometers} Km )
                                                        </>} {driver.username} - {driver.online === 1 ? '(Online)' : driver.online === 0 && '(Offline)'}</option>
                                            ))
                                        ) : (
                                            <p>No Employee found.</p>
                                        )}



                                    </select>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    data-bs-dismiss="modal" onClick={handleClickDriverChange}
                                >
                                    Update Employee
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-gray-300 ms-auto"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div
                    className="modal fade"
                    id="modal-vendor"
                    tabIndex={-1}
                    aria-labelledby="modal-vendor"
                    style={{ display: "none" }}
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="mb-0">
                                    <label htmlFor="eventTitle">

                                        Choose Vendor
                                    </label>{" "}

                                    <select
                                        className="form-control select"
                                        name="status"
                                        style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}
                                    >
                                        <option > Select Vendor</option>


                                        {AllDriver.length > 0 ? (

                                            AllDriver.map(driver => (
                                                <option value={driver._id} key={driver._id} selected={driver._id === DriverId}
                                                >{driver.username}</option>
                                            ))
                                        ) : (
                                            <p>No Vendor found.</p>
                                        )}



                                    </select>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    data-bs-dismiss="modal" onClick={handleClickAsignChange}
                                >
                                    Update vendor
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-gray-300 ms-auto"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>




                <NavBar />

            </main>
        </>

    );
};

export default VendorAllPendingOrder